export class CustomerContact {
  _id: string
  name: string
  email: string
  job_title: string
  phone: string

  constructor(contact: CustomerContact) {
    const errors = []

    if (!contact._id) {
      errors.push('_id')
    }

    if (!contact.name) {
      errors.push('name')
    }

    if (errors.length > 0) {
      throw JSON.stringify(errors)
    }

    this._id = contact._id
    this.name = contact.name
    this.email = contact.email
    this.job_title = contact.job_title
    this.phone = contact.phone
  }
}
